export default __webpack_public_path__ + "icon-bookmark-active.b49393cb.png";